import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-kitchen",
  "use": "icon-kitchen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kitchen\">\r\n  <path d=\"M896 128H128c-35.3 0-64 28.7-64 64v640c0 35.3 28.7 64 64 64h768c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64z m0 704H128V192h768v640z\" fill=\"currentColor\" />\r\n  <path d=\"M256 320h512v64H256zM256 448h256v64H256zM256 576h384v64H256z\" fill=\"currentColor\" />\r\n  <path d=\"M704 448h128v192H704z\" fill=\"currentColor\" />\r\n  <circle cx=\"768\" cy=\"544\" r=\"32\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/kitchen.svg
// module id = 6Cxv
// module chunks = 117